<template>
  <div class="sticky z-10 top-0 header">
    <navBar>
      <template #right>
        <img :src="cardSrc" class="w-5 h-5 mr-4" alt="" @click="goToCart" />
        <img :src="mineSrc" class="w-5 h-5" alt="" @click="goToMine" />
      </template>
    </navBar>
    <div class="mt-2 pt-3 pb-1 bg-white rounded-lg flex flex-col items-center mx-4 w-[calc(100%-2rem)]">
      <div class="w-4/5 min-h-10 rounded-full border border-gray-200 flex items-center justify-center pl-3">
        <img :src="searchSrc" class="w-4 h-4" alt="" />
        <van-search
          :value="iccid"
          @input="handleInput"
          class="flex-1 p-0 mr-2 pl-2"
          :placeholder="$t('query.searchText')"
          @search="handleSearch" />
      </div>

      <van-field
        v-model="date"
        input-align="right"
        readonly
        is-link
        class="flex-1 w-4/5 bg-transparent md:w-4/5 px-0"
        :label="$t('query.queryDate')"
        @click="showCalendar = true" />
      <van-button type="primary" color="#ff7a00" class="w-30 h-9 rounded-xl my-4" @click="handleSearch">
        {{ $t("query.title") }}
      </van-button>
    </div>

    <van-calendar
      class="z-50"
      v-model="showCalendar"
      :default-date="defaultDate"
      type="range"
      color="#ff7a00"
      @confirm="onConfirm"
      :min-date="minDate" />
  </div>
</template>

<script>
import { Field, Calendar, Search } from "vant"
import dayjs from "dayjs"
export default {
  components: {
    [Field.name]: Field,
    [Calendar.name]: Calendar,
    [Search.name]: Search,
  },
  data() {
    return {
      cardSrc: require("@/assets/images/card-icon.png"),
      mineSrc: require("@/assets/images/mine-icon.png"),
      date: dayjs().subtract(1, "month").format("YYYY-MM-DD") + " - " + dayjs().format("YYYY-MM-DD"),
      defaultDate: [dayjs().subtract(1, "month").toDate(), dayjs().toDate()],
      showCalendar: false,

      searchActive: 0,
      searchSrc: require("@/assets/images/search-icon.png"),
      minDate: new Date(2020, 0, 1),
      // iccid: "",
    }
  },
  props: {
    iccid: {
      type: String,
      default: "",
    },
  },
  computed: {},
  methods: {
    onConfirm(date) {
      const [start, end] = date
      this.showCalendar = false
      this.date = `${dayjs(start).format("YYYY-MM-DD")} - ${dayjs(end).format("YYYY-MM-DD")}`
      this.$emit("date-change", this.date)
    },
    goToCart() {
      this.$router.push("/cart")
    },
    handleInput(event) {
      this.iccid = event
      this.$emit("input", event)
    },
    handleSearch() {
      this.$emit("search", this.iccid)
    },
    goToMine() {
      this.$router.push("/mine")
    },
  },
  mounted() {},
}
</script>

<style scoped>
.header {
  background-color: #f7fafc;
  /deep/.van-search__content {
    background-color: transparent;
    padding-left: 0;
  }
  /deep/.van-field__left-icon {
    display: none;
  }
}
</style>
